<template>
  <div class="wgk-product-flag mt-2 mb-2 notice">
    <input type="checkbox" class="featureToggle" style="display: none" :id="prefix + sourceId" checked>
    <label :for="prefix + sourceId">
      <v-btn
        class="mr-2"
        fab
        x-small
        depressed
        disabled
        color="primary"
      >
        <v-icon small>
          mdi-information-variant
        </v-icon>
      </v-btn>
      <span>Hinweis</span>
    </label>
    <div class="wgk-product-flag-text mt-2 mb-2">
      {{ featureText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prefix: String,
    sourceId: String,
    featureText: String
  },
}
</script>

<style scoped>

</style>
